// window is unavailable during SSR, so the current page's URL has to be rebuilt
// from the location state the server hydrated. Takes the `location` slice of the
// Store (or connectLocation's props, which carry the same keys).
const localePrefix = locale => (locale?.code ? `/${locale.code.toLowerCase()}` : '');

export const pagePath = ({ locale, PB_PAGE, pageSearch } = {}) =>
  `${localePrefix(locale)}${PB_PAGE || ''}${pageSearch || ''}`;

export const pageUrl = ({ protocol, host, ...rest } = {}) => `${protocol || 'https:'}//${host || ''}${pagePath(rest)}`;
